/* D128 (3 Nov 2026) The Workwear Co: favourites, team kit reorder, share basket for approval, frequently bought together.
   No app, no server email. Plain ES5-ish, one delegated listener per event type. */
(function () {
  'use strict';
  if (window.__wwcAcct) return;
  window.__wwcAcct = 1;

  var C = window.WWC_ACCT || {};
  var ROOT = C.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var GUEST_KEY = 'wwc_favs';
  var KEY = C.cid ? 'wwc_favs_c' + C.cid : GUEST_KEY;
  var MGR_KEY = 'wwc_mgr_email';
  var NAME_KEY = 'wwc_share_name';

  /* ---------- helpers ---------- */
  function ls(k, v) {
    try {
      if (arguments.length === 1) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function readList(k) {
    try { var a = JSON.parse(ls(k) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : []; } catch (e) { return []; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(cents, cur) {
    var n = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(C.locale || 'en-GB', { style: 'currency', currency: cur || C.currency || 'GBP' }).format(n); }
    catch (e) { return (cur === 'EUR' ? '€' : '£') + n.toFixed(2); }
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j && (j.description || j.message) || 'Request failed'); e.data = j; throw e; } return j; }); });
  }
  function addToCart(items) {
    return postJSON(ROOT + 'cart/add.js', { items: items }).then(function (j) { refreshCart(); return j; });
  }
  function refreshCart() {
    /* Header bubble + drawer: wwc-cart-sync.js already re-counts after any /cart/add fetch. Also ask the theme to refresh its drawer if it listens. */
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }
  var toastTimer;
  function toast(html, ms, cls) {
    var t = document.getElementById('wwc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'wwc-toast';
      t.className = 'wwc-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.className = 'wwc-toast' + (cls ? ' ' + cls : '');
    t.style.bottom = '';
    /* keep clear of the sticky add-to-basket bar when it is on screen */
    var bars = document.querySelectorAll('.wwc-satc, sticky-add-to-cart, .sticky-add-to-cart, .product-sticky-atc');
    for (var i = 0; i < bars.length; i++) {
      var r = bars[i].getBoundingClientRect(), cs = getComputedStyle(bars[i]);
      if (r.height && r.top < window.innerHeight - 4 && r.bottom > window.innerHeight / 2 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0) {
        t.style.bottom = 'calc(' + Math.round(window.innerHeight - r.top + 12) + 'px + env(safe-area-inset-bottom))';
      }
    }
    t.innerHTML = html;
    void t.offsetWidth;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, ms || 4200);
  }

  /* ---------- favourites store ---------- */
  var favs = readList(KEY);
  (function mergeOnLoad() {
    var changed = false;
    function has(h) { return favs.some(function (f) { return f.h === h; }); }
    if (C.cid) {
      // Guest list saved before signing in on this device moves into the account list.
      readList(GUEST_KEY).forEach(function (f) { if (!has(f.h)) { favs.push(f); changed = true; } });
      ls(GUEST_KEY, null);
      // Profile list (customer.metafields.wwc.favourites) wins across devices.
      (C.mf || []).forEach(function (h) { h = String(h || '').trim(); if (h && !has(h)) { favs.push({ h: h, t: 0 }); changed = true; } });
    }
    if (changed) save(true);
  })();
  function isFav(h) { return favs.some(function (f) { return f.h === h; }); }
  var syncTimer;
  function save(silent) {
    ls(KEY, JSON.stringify(favs.slice(0, 200)));
    paint();
    if (C.cid && C.proxy) {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        // App proxy (custom app + AWS Lambda) writes customer.metafields.wwc.favourites + wwc.favourites_updated_at.
        postJSON(C.proxy, { favourites: favs.map(function (f) { return f.h; }), ids: favs.map(function (f) { return f.id || null; }) }).catch(function () {});
      }, silent ? 0 : 800);
    }
  }
  function toggleFav(h, id) {
    if (!h) return false;
    var on;
    if (isFav(h)) { favs = favs.filter(function (f) { return f.h !== h; }); on = false; }
    else { favs.unshift({ h: h, id: id ? Number(id) : null, t: Date.now() }); on = true; }
    save();
    return on;
  }
  function paint() {
    var n = favs.length;
    document.querySelectorAll('[data-wwc-fav]').forEach(function (b) {
      var on = isFav(b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
      var lbl = b.getAttribute('aria-label') || '';
      lbl = lbl.replace(/^(Add|Remove) /, on ? 'Remove ' : 'Add ').replace(/ (to|from) favourites$/, on ? ' from favourites' : ' to favourites');
      b.setAttribute('aria-label', lbl);
      var txt = b.querySelector('[data-wwc-fav-txt]');
      var ts = on ? 'Saved to favourites' : 'Add to favourites';
      if (txt && txt.textContent !== ts) txt.textContent = ts;
    });
    document.querySelectorAll('[data-wwc-fav-count]').forEach(function (el) {
      var s = n > 99 ? '99+' : String(n);
      if (el.textContent !== s) el.textContent = s;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
    document.querySelectorAll('[data-wwc-fav-head]').forEach(function (a) {
      a.classList.toggle('has-favs', n > 0);
      a.setAttribute('aria-label', n ? 'Favourites (' + n + ')' : 'Favourites');
    });
    document.querySelectorAll('[data-wwc-fav-count-text]').forEach(function (el) { var s = n ? '(' + n + ')' : ''; if (el.textContent !== s) el.textContent = s; });
  }
  window.WWCFavourites = { list: function () { return favs.slice(); }, toggle: toggleFav, has: isFav };
  // Other tabs.
  window.addEventListener('storage', function (e) { if (e.key === KEY) { favs = readList(KEY); paint(); renderFavPage(); } });

  /* ---------- favourites page ---------- */
  var favCache = {};
  function fetchProduct(h) {
    if (favCache[h]) return favCache[h];
    favCache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return favCache[h];
  }
  function cardHTML(p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var first = avail[0] || p.variants[0];
    var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=480' : p.featured_image + '?width=480') : '';
    var single = p.variants.length === 1 && /^Default Title$/i.test(p.variants[0].title);
    var opts = avail.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '" data-taxable="' + (v.taxable ? 1 : 0) + '">' + esc(v.title) + '</option>';
    }).join('');
    var price = first ? money(first.price) + (first.taxable ? ' <span>ex VAT</span>' : '') : '';
    return '<article class="wwc-card" data-wwc-fav-card data-handle="' + esc(p.handle) + '">' +
      '<a class="wwc-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="480" height="480">' : '') + '</a>' +
      '<button type="button" class="wwc-fav wwc-fav--card is-active" data-wwc-fav data-handle="' + esc(p.handle) + '" data-id="' + p.id + '" aria-pressed="true" aria-label="Remove ' + esc(p.title) + ' from favourites">' +
        '<svg class="icon icon-wwc-heart icon--medium icon--thick shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path class="wwc-heart-path" d="M12 20.25C12 20.25 2.625 15 2.625 8.625C2.625 7.49803 3.01546 6.40585 3.72996 5.53437C4.44445 4.66289 5.43884 4.0661 6.54393 3.84554C7.64903 3.62498 8.79657 3.79427 9.79131 4.32462C10.7861 4.85496 11.5665 5.71375 12 6.75C12.4335 5.71375 13.2139 4.85496 14.2087 4.32462C15.2034 3.79427 16.351 3.62498 17.4561 3.84554C18.5612 4.0661 19.5555 4.66289 20.27 5.53437C20.9845 6.40585 21.375 7.49803 21.375 8.625C21.375 15 12 20.25 12 20.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="wwc-card__body">' +
        '<p class="wwc-card__vendor">' + esc(p.vendor) + '</p>' +
        '<a class="wwc-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="wwc-card__price" data-wwc-price>' + price + '</p>' +
        (avail.length ?
          (single ? '<input type="hidden" data-wwc-variant value="' + first.id + '">' :
            '<label class="wwc-select"><span class="visually-hidden">Colour and size</span><select data-wwc-variant>' + opts + '</select></label>') +
          '<div class="wwc-card__actions">' +
            '<label class="wwc-qty"><span class="visually-hidden">Quantity</span><button type="button" class="wwc-qty__btn" data-wwc-qty="-1" aria-label="Fewer">−</button><input type="number" inputmode="numeric" min="1" max="9999" value="1" data-wwc-kit-qty><button type="button" class="wwc-qty__btn" data-wwc-qty="1" aria-label="More">+</button></label>' +
            '<button type="button" class="wwc-btn wwc-btn--primary wwc-btn--grow" data-wwc-fav-add>Add to basket</button>' +
          '</div>' +
          '<a class="wwc-card__link" href="' + esc(p.url) + '">Add your logo</a>'
        : '<div class="wwc-card__actions"><a class="wwc-btn wwc-btn--ghost wwc-btn--grow" href="' + esc(p.url) + '">Out of stock, see options</a></div>') +
      '</div></article>';
  }
  function renderFavPage() {
    var page = document.querySelector('[data-wwc-fav-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wwc-fav-grid]');
    var empty = page.querySelector('[data-wwc-fav-empty]');
    var bar = page.querySelector('[data-wwc-fav-bar]');
    if (!favs.length) { grid.innerHTML = ''; empty.hidden = false; bar.hidden = true; return; }
    empty.hidden = true;
    var list = favs.slice(0, 60);
    Promise.all(list.map(function (f) { return fetchProduct(f.h); })).then(function (ps) {
      var html = '';
      ps.forEach(function (p, i) {
        if (!p) return; // unpublished / removed product: skip quietly
        if (!list[i].id) list[i].id = p.id;
        html += cardHTML(p);
      });
      grid.innerHTML = html || '';
      if (!html) { empty.hidden = false; bar.hidden = true; } else { bar.hidden = false; }
    });
  }

  /* ---------- share basket for approval ---------- */
  function b64url(str) {
    var b = btoa(unescape(encodeURIComponent(str)));
    return b.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function unb64url(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    return decodeURIComponent(escape(atob(s)));
  }
  function buildShare(cart) {
    var origin = location.origin;
    var items = cart.items || [];
    var hasProps = items.some(function (i) { return i.properties && Object.keys(i.properties).some(function (k) { return i.properties[k] !== null && i.properties[k] !== ''; }); });
    // Shopify cart permalink: same variants + quantities, lands in the basket (storefront=true) so the manager can check it first.
    var perma = origin + ROOT + 'cart/' + items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') + '?storefront=true';
    var link = perma, kept = true;
    if (hasProps) {
      // Branded lines: permalinks only carry properties for the first line, so we pass the whole basket (with logo references).
      var data = items.map(function (i) {
        var p = {};
        Object.keys(i.properties || {}).forEach(function (k) { var v = i.properties[k]; if (v !== null && v !== '') p[k] = v; });
        return [i.variant_id, i.quantity, p];
      });
      var restore = origin + ROOT + 'cart?wwc_basket=' + b64url(JSON.stringify(data));
      if (restore.length <= 7000) link = restore; else kept = false;
    }
    var lines = items.map(function (i) {
      var v = i.variant_title && !/^Default Title$/i.test(i.variant_title) ? ' (' + i.variant_title + ')' : '';
      return i.quantity + ' x ' + i.product_title + v + ' - ' + money(i.final_line_price, cart.currency);
    });
    return { link: link, lines: lines, total: money(cart.total_price, cart.currency), count: items.length, kept: kept, perma: perma };
  }
  function shareText(s, name, note) {
    var t = 'Hi, could you approve this basket from ' + (C.shop || 'The Workwear Co') + '?\n\n' +
      s.lines.join('\n') + '\n\nSubtotal: ' + s.total + ' ex VAT (delivery and VAT are shown at checkout)\n' +
      (note ? '\nNote: ' + note + '\n' : '') +
      '\nOpen the basket: ' + s.link + '\n' +
      (s.kept ? '' : '\n(Logo details are saved on the original basket.)\n') +
      (name ? '\nThanks,\n' + name : '');
    return t;
  }
  function openShare() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || !cart.items.length) { toast('Your basket is empty.'); return; }
      var s = buildShare(cart);
      var dlg = document.getElementById('wwc-share');
      if (!dlg) {
        dlg = document.createElement('div');
        dlg.id = 'wwc-share';
        dlg.className = 'wwc-sheet';
        dlg.setAttribute('role', 'dialog');
        dlg.setAttribute('aria-modal', 'true');
        dlg.setAttribute('aria-labelledby', 'wwc-share-title');
        document.body.appendChild(dlg);
      }
      var mgr = ls(MGR_KEY) || '';
      var name = ls(NAME_KEY) || C.name || '';
      dlg.innerHTML =
        '<div class="wwc-sheet__scrim" data-wwc-share-close></div>' +
        '<div class="wwc-sheet__panel">' +
          '<button type="button" class="wwc-sheet__x" data-wwc-share-close aria-label="Close">×</button>' +
          '<h2 class="wwc-sheet__title" id="wwc-share-title">Share basket for approval</h2>' +
          '<p class="wwc-sheet__sub">Send this basket to your manager or buyer. They open the link and the same items load into their basket, ready to check out.</p>' +
          '<ul class="wwc-sheet__lines">' + s.lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' +
          '<p class="wwc-sheet__total">Subtotal <strong>' + esc(s.total) + '</strong> <span>ex VAT</span></p>' +
          '<div class="wwc-sheet__fields">' +
            '<label><span>Manager email <em>(optional)</em></span><input type="email" autocomplete="email" data-wwc-mgr value="' + esc(mgr) + '" placeholder="manager@company.co.uk"></label>' +
            '<label><span>Your name <em>(optional)</em></span><input type="text" autocomplete="name" data-wwc-name value="' + esc(name) + '"></label>' +
            '<label><span>Note <em>(optional)</em></span><input type="text" data-wwc-note placeholder="e.g. PO number or site"></label>' +
          '</div>' +
          '<div class="wwc-sheet__actions">' +
            '<a class="wwc-btn wwc-btn--wa" data-wwc-share-wa href="#" target="_blank" rel="noopener">WhatsApp</a>' +
            '<a class="wwc-btn wwc-btn--primary" data-wwc-share-mail href="#">Email</a>' +
            '<button type="button" class="wwc-btn wwc-btn--ghost" data-wwc-share-copy>' + (navigator.share && matchMedia('(pointer: coarse)').matches ? 'Share link' : 'Copy link') + '</button>' +
          '</div>' +
          '<p class="wwc-sheet__fine">Nothing is sent by us: WhatsApp or your email app opens with the message ready to send.</p>' +
        '</div>';
      dlg._share = s;
      function refreshLinks() {
        var m = dlg.querySelector('[data-wwc-mgr]').value.trim();
        var n = dlg.querySelector('[data-wwc-name]').value.trim();
        var note = dlg.querySelector('[data-wwc-note]').value.trim();
        ls(MGR_KEY, m || null);
        ls(NAME_KEY, n || null);
        var text = shareText(s, n, note);
        dlg._text = text;
        dlg.querySelector('[data-wwc-share-wa]').href = 'https://wa.me/?text=' + encodeURIComponent(text);
        dlg.querySelector('[data-wwc-share-mail]').href = 'mailto:' + encodeURIComponent(m).replace(/%40/g, '@') +
          '?subject=' + encodeURIComponent('Basket for approval - ' + (C.shop || 'The Workwear Co') + (n ? ' (' + n + ')' : '')) +
          '&body=' + encodeURIComponent(text);
      }
      dlg.addEventListener('input', refreshLinks);
      refreshLinks();
      dlg.classList.add('is-open');
      document.documentElement.classList.add('wwc-sheet-open');
      var panel = dlg.querySelector('.wwc-sheet__panel');
      panel.setAttribute('tabindex', '-1');
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 60); // no auto-keyboard on phones
    }).catch(function () { toast('Sorry, we couldn\u2019t read your basket. Please try again.'); });
  }
  function closeShare() {
    var d = document.getElementById('wwc-share');
    if (d) d.classList.remove('is-open');
    document.documentElement.classList.remove('wwc-sheet-open');
  }
  function copyLink(dlg) {
    var s = dlg._share;
    if (navigator.share && matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: 'Basket for approval', text: dlg._text, url: s.link }).catch(function () {});
      return;
    }
    var done = function () { toast('Link copied. Paste it anywhere to share your basket.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(s.link).then(done, fallback); else fallback();
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = s.link; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { window.prompt('Copy this link', s.link); }
      ta.remove();
    }
  }
  // Shared branded basket: /cart?wwc_basket=...
  (function restoreShared() {
    var m = /[?&]wwc_basket=([^&#]+)/.exec(location.search);
    if (!m) return;
    var data;
    try { data = JSON.parse(unb64url(decodeURIComponent(m[1]))); } catch (e) { return; }
    if (!Array.isArray(data) || !data.length) return;
    var items = data.filter(function (r) { return r && r[0] && r[1]; }).map(function (r) { return { id: Number(r[0]), quantity: Number(r[1]), properties: r[2] || {} }; });
    function ready() {
      var bar = document.createElement('div');
      bar.className = 'wwc-restore';
      bar.setAttribute('role', 'dialog');
      bar.setAttribute('aria-label', 'Shared basket');
      bar.innerHTML = '<p><strong>A basket was shared with you</strong> (' + items.length + ' line' + (items.length === 1 ? '' : 's') + '). Load it? This replaces what is in your basket now.</p>' +
        '<div><button type="button" class="wwc-btn wwc-btn--primary" data-go>Load basket</button><button type="button" class="wwc-btn wwc-btn--ghost" data-no>Not now</button></div>';
      document.body.appendChild(bar);
      bar.querySelector('[data-no]').addEventListener('click', function () { bar.remove(); history.replaceState(null, '', ROOT + 'cart'); });
      bar.querySelector('[data-go]').addEventListener('click', function () {
        var b = this; b.disabled = true; b.textContent = 'Loading\u2026';
        postJSON(ROOT + 'cart/clear.js', {}).then(function () { return postJSON(ROOT + 'cart/add.js', { items: items }); })
          .then(function () { location.replace(ROOT + 'cart'); })
          .catch(function (e) { b.disabled = false; b.textContent = 'Load basket'; toast(esc((e && e.message) || 'Some items could not be added.')); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  })();

  /* ---------- frequently bought together ---------- */
  function initFBT(root) {
    if (!root || root._wwc) return;
    root._wwc = 1;
    var url = root.getAttribute('data-url');
    var go = function () {
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var items = doc.querySelector('[data-wwc-fbt-items]');
        var rows = items ? items.querySelectorAll('[data-wwc-fbt-row]') : [];
        if (!rows.length) { root.remove(); return; }
        var list = root.querySelector('[data-wwc-fbt-list]');
        rows.forEach(function (r) { list.appendChild(document.importNode(r, true)); });
        root.hidden = false;
        syncCurrent(root);
        totalFBT(root);
      }).catch(function () { root.remove(); });
    };
    // The block is display:none until filled, so it cannot be observed; fetch once the page has settled.
    var later = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(go, { timeout: 2500 }); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  }
  function currentVariantInput() {
    return document.querySelector('form[action*="/cart/add"] [name="id"]:not([disabled])');
  }
  function syncCurrent(root) {
    var cur = root.querySelector('[data-wwc-fbt-row][data-current] [data-wwc-fbt-variant]');
    var main = currentVariantInput();
    if (cur && main && main.value) cur.value = main.value;
    var lbl = root.querySelector('[data-wwc-fbt-current-label]');
    if (lbl) {
      var sel = document.querySelector('variant-selects, variant-radios');
      var txt = '';
      try {
        var vj = sel && sel.querySelector('script[type="application/json"]');
        var vs = vj ? JSON.parse(vj.textContent) : null;
        if (Array.isArray(vs) && main) { var v = vs.filter(function (x) { return String(x.id) === String(main.value); })[0]; if (v) { txt = v.title; if (cur) { cur.setAttribute('data-price', v.price); cur.setAttribute('data-taxable', v.taxable); } } }
      } catch (e) {}
      if (txt && !/^Default Title$/i.test(txt)) lbl.textContent = txt;
    }
  }
  function totalFBT(root) {
    var n = 0, sum = 0;
    root.querySelectorAll('[data-wwc-fbt-row]').forEach(function (row) {
      var on = row.querySelector('[data-wwc-fbt-check]').checked;
      row.classList.toggle('is-off', !on);
      var v = row.querySelector('[data-wwc-fbt-variant]');
      var opt = v && v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      var price = opt ? Number(opt.getAttribute('data-price')) || 0 : 0;
      var taxable = opt ? String(opt.getAttribute('data-taxable')) !== 'false' && String(opt.getAttribute('data-taxable')) !== '0' : true;
      var pe = row.querySelector('[data-wwc-fbt-price]');
      if (pe && price) pe.innerHTML = esc(money(price)) + (taxable ? ' <span>ex VAT</span>' : '');
      if (on) { n++; sum += price; }
    });
    var ne = root.querySelector('[data-wwc-fbt-n]'); if (ne) ne.textContent = n;
    var te = root.querySelector('[data-wwc-fbt-total]'); if (te) te.textContent = money(sum) + ' ex VAT';
    var btn = root.querySelector('[data-wwc-fbt-add]'); if (btn) btn.disabled = n === 0;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('[data-wwc-fav]'))) {
      e.preventDefault(); e.stopPropagation();
      var on = toggleFav(b.getAttribute('data-handle'), b.getAttribute('data-id'));
      b.classList.remove('is-pop'); void b.offsetWidth; if (on) b.classList.add('is-pop');
      toast('<svg class="wwc-toast__heart" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-7.5-4.6-9.6-9.1C.9 8.6 3 5 6.6 5c2.1 0 3.6 1.2 4.4 2.6h2C13.8 6.2 15.3 5 17.4 5 21 5 23.1 8.6 21.6 11.9 19.5 16.4 12 21 12 21z" fill="' + (on ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg><span>' + (on ? 'Added to favourites' : 'Removed from favourites') + '</span>', 2000, 'wwc-toast--fav');
      var card = b.closest('[data-wwc-fav-card]');
      if (card && !on) { card.remove(); if (!favs.length) renderFavPage(); }
      return;
    }
    if ((b = t.closest('[data-wwc-qty]'))) {
      var inp = b.parentNode.querySelector('input');
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.getAttribute('data-wwc-qty')));
      return;
    }
    if ((b = t.closest('[data-wwc-fav-add]'))) {
      var c = b.closest('[data-wwc-fav-card]');
      var vid = c.querySelector('[data-wwc-variant]').value;
      var q = parseInt(c.querySelector('[data-wwc-kit-qty]').value, 10) || 1;
      b.disabled = true;
      addToCart([{ id: Number(vid), quantity: q }]).then(function () {
        b.textContent = 'Added'; toast('Added to your basket. <a href="' + esc(C.cartUrl || ROOT + 'cart') + '">View basket</a>');
        setTimeout(function () { b.textContent = 'Add to basket'; b.disabled = false; }, 1800);
      }).catch(function (err) { b.disabled = false; toast(esc(err.message || 'Could not add this item.')); });
      return;
    }
    if ((b = t.closest('[data-wwc-fav-addall]'))) {
      var all = [];
      document.querySelectorAll('[data-wwc-fav-card]').forEach(function (cc) {
        var v = cc.querySelector('[data-wwc-variant]'); var qq = cc.querySelector('[data-wwc-kit-qty]');
        if (v && v.value) all.push({ id: Number(v.value), quantity: parseInt(qq && qq.value, 10) || 1 });
      });
      if (!all.length) return;
      b.disabled = true;
      addToCart(all).then(function () { toast('Added ' + all.length + ' item' + (all.length === 1 ? '' : 's') + ' to your basket. <a href="' + esc(C.cartUrl || ROOT + 'cart') + '">View basket</a>'); })
        .catch(function (err) { toast(esc(err.message || 'Some items could not be added.')); }).then(function () { b.disabled = false; });
      return;
    }
    if ((b = t.closest('[data-wwc-fav-clear]'))) {
      if (!window.confirm('Remove all favourites?')) return;
      favs = []; save(); renderFavPage();
      return;
    }
    if ((b = t.closest('[data-wwc-reorder]'))) {
      var item = b.closest('[data-wwc-kit-item]');
      var lines;
      try { lines = JSON.parse(item.querySelector('[data-wwc-kit-lines]').textContent); } catch (er) { lines = []; }
      if (!lines.length) return;
      var qty = parseInt(item.querySelector('[data-wwc-kit-qty]').value, 10) || 1;
      var main = lines.filter(function (l) { return l.main; })[0];
      var ratio = main && main.quantity ? qty / main.quantity : 1;
      var suffix = '-r' + Date.now().toString(36);
      var items = lines.map(function (l) {
        var p = {};
        Object.keys(l.properties || {}).forEach(function (k) { if (l.properties[k] !== '') p[k] = l.properties[k]; });
        if (p._wwc_group) p._wwc_group = String(p._wwc_group) + suffix; // fresh group so a repeat reorder never merges with an open basket line
        var role = p._wwc_role;
        var q = l.main ? qty : (role === 'setup' ? l.quantity : Math.max(1, Math.round(l.quantity * ratio)));
        return { id: l.id, quantity: q, properties: p };
      });
      b.disabled = true; var old = b.textContent; b.textContent = 'Adding\u2026';
      addToCart(items).then(function () {
        b.textContent = 'Added'; toast('Added to your basket with your logo details. <a href="' + esc(C.cartUrl || ROOT + 'cart') + '">View basket</a>');
        setTimeout(function () { b.textContent = old; b.disabled = false; }, 1800);
      }).catch(function (err) { b.textContent = old; b.disabled = false; toast(esc(err.message || 'Could not add this item.')); });
      return;
    }
    if ((b = t.closest('[data-wwc-share]'))) { e.preventDefault(); openShare(); return; }
    if (t.closest('[data-wwc-share-close]')) { closeShare(); return; }
    if ((b = t.closest('[data-wwc-share-copy]'))) { copyLink(document.getElementById('wwc-share')); return; }
    if ((b = t.closest('[data-wwc-fbt-add]'))) {
      var root = b.closest('[data-wwc-fbt]');
      syncCurrent(root);
      var sel = [];
      root.querySelectorAll('[data-wwc-fbt-row]').forEach(function (row) {
        if (!row.querySelector('[data-wwc-fbt-check]').checked) return;
        var v = row.querySelector('[data-wwc-fbt-variant]');
        if (v && v.value) sel.push({ id: Number(v.value), quantity: 1 });
      });
      if (!sel.length) return;
      b.disabled = true;
      addToCart(sel).then(function () { toast('Added ' + sel.length + ' item' + (sel.length === 1 ? '' : 's') + ' to your basket. <a href="' + esc(C.cartUrl || ROOT + 'cart') + '">View basket</a>'); })
        .catch(function (err) { toast(esc(err.message || 'Some items could not be added.')); }).then(function () { b.disabled = false; });
      return;
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var fbt = t.closest('[data-wwc-fbt]');
    if (fbt) { totalFBT(fbt); return; }
    var card = t.closest('[data-wwc-fav-card]');
    if (card && t.matches('[data-wwc-variant]')) {
      var o = t.options[t.selectedIndex];
      card.querySelector('[data-wwc-price]').innerHTML = esc(money(o.getAttribute('data-price'))) + (o.getAttribute('data-taxable') === '1' ? ' <span>ex VAT</span>' : '');
    }
    if (t.closest('form[action*="/cart/add"]')) { document.querySelectorAll('[data-wwc-fbt]').forEach(function (r) { if (!r.hidden) { syncCurrent(r); totalFBT(r); } }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeShare(); });

  function boot() {
    paint();
    renderFavPage();
    document.querySelectorAll('[data-wwc-fbt]').forEach(initFBT);
    // Cards added later (infinite scroll, filters, quick view, cart drawer re-render).
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        requestAnimationFrame(function () { pending = false; paint(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
